import Cards from "./cards/Cards";
import {fetch} from '../../../../../wp-includes/js/dist/vendor/wp-polyfill-fetch';


const {Component} = wp.element;
class MarketingMaterialGridPosts extends Component {
     postObject = JSON.parse(marketingMaterialsPosts);
     
     state ={
        statePosts: this.postObject.posts,
        page: this.postObject.paged,
        totalPages: this.postObject.max_num_pages
     }
    
    
    //const [statePosts,setStatePosts] = useState(posts);
    //const [page, setPage] = useState(paged);
    //const [totalPages,setTotalPages] = useState(max_num_pages);
   
    handleFectch =(async()=>{
        const page_number = this.state.page + 1;
        const response = await fetch(this.postObject.base_url +'?page_number='+page_number );
        const posts = await response.json()
        this.setState({
            statePosts: [...this.state.statePosts,...posts.posts],
            page: posts.paged,
            totalPages: posts.max_num_pages
        
        });
    });
       


    render (){
       
        return(
        <div className="mt-5 mb-3">
            <div className="row">

                {
                    this.state.statePosts.map((post)=>{
                        return(
                           <Cards post={post}/>
                        )
                    })
                }
            </div>    
            <div className="row">
                { (this.state.page !== this.state.totalPages) && <button onClick={this.handleFectch} type="button" className="vc_btn3 vc_btn3-style-modern mx-auto">More</button>    }
            </div>    
        </div>
        )
    }
}

export default MarketingMaterialGridPosts;
 